import React, { useEffect, useState } from 'react'
import SlideUpWrapper from '../../../components/Transitions/SlideUpWrapper'
import IssuerNavigator from '../../../components/DashBoard/IssuerNavigator'
import styles from "../CompanyProfile.module.css";
import templateStyles from "../Templates/Templates.module.css";
import { useLocation, useParams } from 'react-router-dom';
import Loader from '../../../components/Loader';



import API from "../../../ApiConfig";
import { GET_WALLET_DETAILS, ISSUER_ADJUST_CREDITS, UPDATE_ISSUER_PER_SEARCH_CREDIT, UPDATE_ISSUER_WALLET_STATUS } from '../../../Utils/constant';
import cogoToast from 'cogo-toast-react-17-fix';
const CreditHandler = () => {
    const location=useLocation()
    const [is_active, setIsActive]=useState(false)
    const [currentCredits, setCurrentCredits]=useState("")

    const [userDetails, setUserDetails]=useState("")

    const [perSearchCredit, setPerSearchCredit]=useState("100")
    const [loading, setLoading]=useState(false)
    const {email}=useParams()
    const [amount, setAmount]=useState("")
    const [description, setDescription]=useState("")
    const handleCredit=()=>{
        setIsActive(!is_active)
        setLoading(true)
        let apiData={
            email:email,
            active:!is_active
        }
        API.post(UPDATE_ISSUER_WALLET_STATUS, apiData)
        .then(res=>{
            if(res.status==200){
                setLoading(false)
                cogoToast.success(res.data.data)
            }
        })


        .catch(err=>{
            setLoading(false)
            console.log(err);
            
        })
    }
    const getWalletDetails=()=>{
        setLoading(true)
        API.get(GET_WALLET_DETAILS+email)
        .then(res=>{
            if(res.status==200){
                setLoading(false)
                setIsActive(res.data.data.wallet_active)
                setCurrentCredits(res.data.data.credits)
                setUserDetails(res.data.data)
            }
        })
        .catch(err=>{
            setLoading(false)
            console.log(err);
            
        })
    }
    const setCredits=(e)=>{
        e.preventDefault()
        setLoading(true)
        let apiData={
            email:email,
            per_search_credit:perSearchCredit
        }
        API.post(UPDATE_ISSUER_PER_SEARCH_CREDIT,apiData)
        .then(res=>{
            if(res.status==200){
                setLoading(false)
                cogoToast.success(res.data.data)
                getWalletDetails()
            }
        })

        .catch(err=>{
            setLoading(false)
            cogoToast.error(err.response.data.message)                                                                                                                                                                                                                                                                              
            
        })
    }

    const handleCredits=(e,action)=>{
        e.preventDefault()
        if(amount==""){
            cogoToast.error("Enter Amount to Credit or Debit")
        }
        else if(description==""){
            cogoToast.error("Enter Description")
        }
        else{
        setLoading(true)

        let apiData={
            email:email,
            amount:amount,
            action:action,
            description:description
        }
        API.post(ISSUER_ADJUST_CREDITS, apiData)
        .then(res=>{
            if(res.data.status==200){
                setLoading(false)
                cogoToast.success(res.data.message)
                getWalletDetails()
                setAmount("")
                setDescription("")
            }
        })
        .catch(err=>{
            setLoading(false)
            cogoToast.error(err.response.data.message)
            
        })
        
    }
    }
    useEffect(()=>{
        getWalletDetails()

    },[])
  return (
    
    <SlideUpWrapper direction="slide-left">


        <Loader isOpen={loading}/>
            <div className={[styles.companyProfile, templateStyles.templateHeader].join(" ")}>
                <IssuerNavigator
                    title={`Credit Management ${location.state.company_name&& `(${location.state.company_name})`}`}
                    actions={()=>{}} step={'/users'} />
            </div>
        <div className='w-100 bg-gray-100 p-4 flex items-center justify-center row'>
            <div className=" w-50 bg-white rounded-xl shadow-md p-4 border border-gray-200 flex items-center justify-between m-10"> 

      <div className="text-gray-600 space-y-2">

      <div>
                <h2>Email</h2>
                {loading?<div className='shimmer'></div>:
                <div className={styles.balance}><span id="balance">{userDetails.issuer_email}</span></div>}
            </div>
            <div>
                <h2>Per search credits</h2>
                {loading?<div className='shimmer'></div>:
                <div className={styles.balance}><span id="balance">{userDetails.per_search_credit_rate}</span></div>}
            </div>
      <div>
                <h2>Current Balance</h2>
                {loading?<div className='shimmer'></div>:
                <div className={styles.balance}><span id="balance">{currentCredits}</span></div>}
            </div>



            <div>
                <h2>Set per search credits</h2>
                <div><input type="text" className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:border-blue-500" value={perSearchCredit} onChange={(e)=>setPerSearchCredit(e.target.value)}/> <button className='btn btn-primary' onClick={(e)=>setCredits(e)}>Set Credit</button></div>
            </div>
    
      </div>
      <div className='w-25 text-center'>
                <h2>Wallet Service</h2>




                <div className="display-flex align-item-cen justify-center gap-2">
                <div className="checkbox-wrapper-22">
                                  <label
                                    className="switch"
                                    htmlFor={`checkbox`}
                                  >
                                    <input
                                      type="checkbox"
                                      id={`checkbox`}
                                      checked={is_active}
                                      onChange={()=>handleCredit()}
                                    />
                                    <div className="slider round"></div>
                                  </label>
                                </div>

                <div className={`${is_active? 'Complete':'Rejected'}`} style={{width:"auto"}}>{is_active?"Activated":"Deactivated"}</div>
                </div>
            </div>

    </div>


    <div className=" w-50 bg-white rounded-xl shadow-md p-4 border border-gray-200 flex items-center justify-center row m-5"> 
      <div className='w-100 flex align-center justify-center'>
                <h2>Credit/Debit Credits</h2>
      </div>

      <div className='w-50 flex align-center row'>
        <div className='w-100'>
                    <label for="credit-amount" className={styles.balance}>Amount</label>
                    {loading?<div className='shimmer'></div>:
                    <input type="text" value={amount} className='input' id="credit-amount" placeholder="Enter amount to credit/debit" onChange={(e)=>setAmount(e.target.value)}/>}
        </div>
        <div className='w-100 mt-5'>

                    <label for="credit-amount" className={styles.balance}>Description</label>
                    {loading?<div className='shimmer'></div>:
                    <input type="text" value={description} className='input' id="credit-amount" placeholder="Enter Description" onChange={(e)=>setDescription(e.target.value)}/>}
        </div>
      </div>


      <div className='w-100 flex align-center justify-center'>
        <button className={`btn ${styles.accept}`} onClick={(e)=>handleCredits(e, 'CREDIT')}>Credit Amount</button>
        <button className={`btn ${styles.reject}`} onClick={(e)=>handleCredits(e, 'DEBIT')}>Debit Amount</button>
    </div>
    </div>
    </div>

    </SlideUpWrapper>
  )
}

export default CreditHandler